// extracted by mini-css-extract-plugin
export default {"whySpotifyArticles":"WhySpotifyArticles_whySpotifyArticles__kmZw7","whyArticlesSubHeading":"WhySpotifyArticles_whyArticlesSubHeading__gECRm"};